import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CountryISO, SearchCountryField } from 'ngx-intl-tel-input';

@Component({
  selector: 'app-investor-assistant-section',
  templateUrl: './investor-assistant-section.component.html',
  styleUrls: ['./investor-assistant-section.component.scss']
})
export class InvestorAssistantSectionComponent {

  @Input() assistantForm!: FormGroup;

  preferredCountries: CountryISO[] = [CountryISO.Thailand];
  countryISO = CountryISO;
  searchCountryField = [SearchCountryField.Iso2, SearchCountryField.Name];

  get f() {
    return this.assistantForm.controls;
  }

  get isReady(): boolean {
    return !!this.assistantForm;
  }

}
